// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__jSYny","ant-menu-title-content":"menu_ant-menu-title-content__uTpFE","group_item":"menu_group_item__Te7lJ"};